import { render, staticRenderFns } from "./SettingExamTimeAndExamPassScore.vue?vue&type=template&id=068bf728&scoped=true&"
import script from "./SettingExamTimeAndExamPassScore.vue?vue&type=script&lang=js&"
export * from "./SettingExamTimeAndExamPassScore.vue?vue&type=script&lang=js&"
import style0 from "./SettingExamTimeAndExamPassScore.vue?vue&type=style&index=0&id=068bf728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bf728",
  null
  
)

export default component.exports